export default {
    eos_endpoint: 'https://api-kylin.eoslaomao.com',
    put_endpoint: 'https://staging-api.put.dev',
    items_for_sale: {
        storage: 596724,
        cpu: 596723
    }
}